module.exports = __webpack_public_path__ + "media/images/technology/patent2-icon-ff7980038d156560ffb49ddd190a77c1.png";